import React, { useState } from "react";
import scentImg1 from "../../assets/slide1.jpg";
import scentImg2 from "../../assets/slide3.jpg";
import scentImg3 from "../../assets/SereneSand.jpg";
import Header from "../layout/Header";

const images = [scentImg1, scentImg2, scentImg3];

const ScentCarousel = () => {
  const [index, setIndex] = useState(0);

  const nextImage = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div style={{ margin: 0, padding: 0, width: "100%" }}>
      {/* ✅ Global reset untuk full width */}
      <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          html, body {
            margin: 0 !important;
            padding: 0 !important;
            overflow-x: hidden;
            width: 100%;
            background-color: #f7f7f5;
          }
          
          body > div,
          #root,
          #root > div {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
          }

          /* ✅ HAPUS PADDING dari section catalog */
          #catalog {
            padding: 0 !important;
            margin: 0 !important;
          }

          /* Responsive carousel width */
          @media (max-width: 1200px) {
            .carousel-wrapper {
              width: 55vw !important;
            }
          }
          @media (max-width: 992px) {
            .carousel-wrapper {
              width: 65vw !important;
            }
          }
          @media (max-width: 768px) {
            .carousel-wrapper {
              width: 75vw !important;
            }
          }
          @media (max-width: 576px) {
            .carousel-wrapper {
              width: 90vw !important;
            }
          }
        `}
      </style>

      <Header />

      {/* ✅ Full width background container */}
      <section
        id="catalog"
        style={{
          backgroundColor: "#f7f7f5",
          width: "100vw",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          position: "relative",
          margin: 0,
          padding: "80px 0", // ✅ Padding atas-bawah saja
        }}
      >
        {/* === Carousel Container === */}
        <div
          className="carousel-wrapper"
          style={{
            position: "relative",
            width: "40vw",
            maxWidth: "600px",
            aspectRatio: "3 / 4",
            overflow: "hidden",
            backgroundColor: "#000",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
          }}
        >
          {/* ✅ No animation - direct image change */}
          <img
            src={images[index]}
            alt={`Scent ${index + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />

          {/* Arrows - Original Style */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              transform: "translateY(-50%)",
              padding: "0 20px",
            }}
          >
            <button
              onClick={prevImage}
              style={{
                background: "none",
                border: "none",
                fontSize: "2.8rem",
                color: "#fff",
                opacity: 0.6,
                cursor: "pointer",
              }}
            >
              ‹
            </button>
            <button
              onClick={nextImage}
              style={{
                background: "none",
                border: "none",
                fontSize: "2.8rem",
                color: "#fff",
                opacity: 0.6,
                cursor: "pointer",
              }}
            >
              ›
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ScentCarousel;